export default __webpack_public_path__ + "static/collecting-e7489075c14b637aa3d89035012fc16f.svg";